module.exports = __webpack_public_path__ + "img/flag_ing.a9a849e3.png";